import { logger } from 'src/helpers/logger';
const log = logger.events.bind(logger, 'events');

class Events {
  events = {};
  happened = {};

  on = function (event, cb) {
    this.events[event] = this.events[event] || [];
    this.events[event].push(cb);
  };

  emit = function (event, data) {
    log('emit', event, data);
    this.happened[event] = typeof data === 'undefined' ? null : data;
    let subscriptions = this.events[event] || [];
    if (subscriptions.length > 0) {
      subscriptions.map((cb) => {
        if (typeof cb === 'function') {
          cb(data);
        } else {
          log('emit fail, cb !== function', event, cb);
        }
      });
    }
  };

  cancel = function (event, cb) {
    let subscriptions = this.events[event] || [];
    let index = subscriptions.indexOf(cb);
    if (index !== -1) {
      // log('cancel ok', event);
      subscriptions.splice(index, 1);
    } else {
      log('cancel fail, cb not found', event);
    }
  };

  clear = function () {
    log('clear');
    this.events = {};
  };

  asap(event, cb) {
    this.on(event, cb);
    if (typeof this.happened[event] !== 'undefined' && cb) cb(this.happened[event]);
  }
}

const events = new Events();

window.lifeapp = window.lifeapp || {};
window.lifeapp.events = events;

export { events };
